<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('服务订单.订单编号')">
                <a-input v-model="queryParam.orderNo" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('服务订单.订单类型')">
                <a-select v-model="queryParam.orderType" allowClear style="width: 100%">
                  <a-select-option v-for="item in orderTypeOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('服务订单.服务类型')">
                <a-select v-model="queryParam.serviceType" allowClear style="width: 100%">
                  <a-select-option v-for="item in serviceTypeOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('服务订单.订单状态')">
                <a-select v-model="queryParam.orderStatus" allowClear style="width: 100%">
                  <a-select-option v-for="item in orderStatusOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('服务订单.用户信息')">
                <a-input v-model="queryParam.userInfo" @pressEnter="handleQuery" allow-clear :placeholder="$t('服务订单.用户信息搜索提示')"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('服务订单.创建时间')">
                <a-range-picker v-model="queryParam.createTimeRange" :placeholder="[$t('通用.文本.创建开始时间'), $t('通用.文本.创建结束时间')]" style="width: 100%" @change="onCreateTimeChange" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['homeservice:homeServiceOrder:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
        <a-button type="default" :loading="exportLoading" @click="handleExport" v-hasPermi="['homeservice:homeServiceOrder:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
      </div>

      <!-- 数据表格 -->
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="servicePicture" slot-scope="text, record">
          <img v-if="record.servicePicture" :src="record.servicePicture" style="width:60px;height:60px;cursor:pointer;" @click="handlePreview(record.servicePicture)" alt=""/>
        </template>
        <template slot="orderType" slot-scope="text, record">
          <a-tag :color="record.orderType === 1 ? 'blue' : 'purple'">
            {{ record.orderTypeName }}
          </a-tag>
        </template>
        <template slot="orderStatus" slot-scope="text, record">
          <a-tag :color="getStatusColor(record.orderStatus)">
            {{ record.orderStatusName }}
          </a-tag>
        </template>
        <template slot="payAmount" slot-scope="text, record">
          <span style="color:#f5222d;font-weight:500;">¥{{ record.payAmount }}</span>
        </template>
        <template slot="hasAddPrice" slot-scope="text, record">
          <a-tag v-if="record.addPriceStatusName" :color="getAddPriceStatusColor(record.addPriceStatus)">
            {{ record.addPriceStatusName }}
          </a-tag>
          <span v-else>-</span>
        </template>
        <template slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </template>
        <template slot="userInfo" slot-scope="text, record">
          {{ $t('服务订单.用户昵称') }}：{{ record.userNickName || '-' }} <br/>
          {{ $t('服务订单.用户手机号') }}：{{ record.userMobile || '-' }} <br/>
        </template>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['homeservice:homeServiceOrder:query']">
            <a-icon type="eye" />{{$t('通用.按钮.详情')}}
          </a>
          <a-divider type="vertical" v-if="record.orderStatus === 0 && record.orderType === 1" />
          <a @click="handleAssignWorker(record)" v-if="record.orderStatus === 0 && record.orderType === 1" v-hasPermi="['homeservice:homeServiceOrder:edit']">
            <a-icon type="user-add" />{{$t('服务订单.指定师傅')}}
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 图片预览 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewCancel">
      <img alt="preview" style="width: 100%" :src="previewUrl" />
    </a-modal>

    <!-- 详情弹窗 -->
    <detail-form ref="detailForm" @ok="getList" />

    <!-- 指定师傅弹窗 -->
    <a-drawer
      :title="$t('服务订单.指定师傅')"
      :width="480"
      :visible="assignWorkerVisible"
      @cancel="assignWorkerCancel"
      @close="assignWorkerCancel"
    >
      <a-form-model ref="assignForm" :model="assignForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item :label="$t('服务订单.选择师傅')" prop="workerId">
          <a-select
            v-model="assignForm.workerId"
            :placeholder="$t('通用.输入.请选择')"
            show-search
            :filter-option="filterOption"
            allow-clear
          >
            <a-select-option v-for="(item, index) in workerList" :key="index" :value="item.id">
              <div style="display:flex;align-items:center;">
                <img v-if="item.avatarImage" :src="item.avatarImage" style="width:30px;height:30px;border-radius:50%;margin-right:8px;" />
                <span>{{ item.realName || item.nickName }} - {{ $t('服务订单.接单量') }}: {{ item.orderCount || 0 }}</span>
              </div>
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-footer">
        <a-button @click="assignWorkerCancel">{{$t('通用.按钮.取消')}}</a-button>
        <a-button type="primary" @click="submitAssignWorker" :loading="assignLoading">{{$t('通用.按钮.确定')}}</a-button>
      </div>
    </a-drawer>
  </page-header-wrapper>
</template>

<script>
import { pageHomeServiceOrder, delHomeServiceOrder, listWorker, assignWorker } from '@/api/homeservice/order'
import DetailForm from './modules/DetailForm'
import { tableMixin } from '@/store/table-mixin'
import { saveAs } from 'file-saver'
import { exportHomeServiceOrder } from '@/api/homeservice/order'

export default {
  name: 'HomeServiceOrder',
  mixins: [tableMixin],
  components: { DetailForm },
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      multiple: true,
      previewVisible: false,
      previewUrl: '',
      exportLoading: false,
      workerList: [],
      assignWorkerVisible: false,
      assignLoading: false,
      currentOrderId: null,
      assignForm: {
        orderId: null,
        workerId: undefined
      },
      queryParam: {
        orderNo: undefined,
        orderType: undefined,
        serviceType: undefined,
        orderStatus: undefined,
        userInfo: undefined,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      // 订单类型：1-上门服务 2-废品服务
      orderTypeOptions: [
        { value: 1, label: this.$t('服务订单.上门服务') },
        { value: 2, label: this.$t('服务订单.废品服务') }
      ],
      // 服务类型：1-上门服务 2-扔垃圾 3-收废品
      serviceTypeOptions: [
        { value: 1, label: this.$t('服务订单.上门服务') },
        { value: 2, label: this.$t('服务订单.扔垃圾') },
        { value: 3, label: this.$t('服务订单.收废品') }
      ],
      // 订单状态：0-待支付 1-待接单 2-待服务 3-服务中 4-已完成 5-已取消
      orderStatusOptions: [
        { value: 0, label: this.$t('服务订单.待支付') },
        { value: 1, label: this.$t('服务订单.待接单') },
        { value: 2, label: this.$t('服务订单.待服务') },
        { value: 3, label: this.$t('服务订单.服务中') },
        { value: 4, label: this.$t('服务订单.已完成') },
        { value: 5, label: this.$t('服务订单.已取消') }
      ],
      columns: [
        { title: this.$t('服务订单.服务主图'), dataIndex: 'servicePicture', scopedSlots: { customRender: 'servicePicture' }, width: 100 },
        { title: this.$t('服务订单.服务名称'), dataIndex: 'serviceName', ellipsis: true, width: 150 },
        { title: this.$t('服务订单.订单编号'), dataIndex: 'orderNo', ellipsis: true, width: 180 },
        { title: this.$t('服务订单.订单类型'), dataIndex: 'orderType', scopedSlots: { customRender: 'orderType' }, width: 100 },
        { title: this.$t('服务订单.服务类型'), dataIndex: 'serviceTypeName', width: 100 },
        { title: this.$t('服务订单.订单状态'), dataIndex: 'orderStatus', scopedSlots: { customRender: 'orderStatus' }, width: 100 },
        { title: this.$t('服务订单.实付金额'), dataIndex: 'payAmount', scopedSlots: { customRender: 'payAmount' }, width: 100 },
        { title: this.$t('服务订单.加价状态'), dataIndex: 'hasAddPrice', scopedSlots: { customRender: 'hasAddPrice' }, width: 80 },
        { title: this.$t('服务订单.用户信息'), dataIndex: 'userInfo', scopedSlots: { customRender: 'userInfo' }, width: 150 },
        { title: this.$t('服务订单.预约时间'), dataIndex: 'serviceTimeRange', width: 180 },
        { title: this.$t('服务订单.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 150 },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, width: 180 }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      const param = { ...this.queryParam }
      // userInfo 搜索框同时搜索昵称和手机号（OR关系），后端接收字段为 nickName
      if (param.userInfo) {
        param.nickName = param.userInfo
        delete param.userInfo
      }
      pageHomeServiceOrder(param).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        orderNo: undefined,
        orderType: undefined,
        serviceType: undefined,
        orderStatus: undefined,
        userInfo: undefined,
        startTime: undefined,
        endTime: undefined,
        createTimeRange: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onCreateTimeChange(dates, dateStrings) {
      this.queryParam.startTime = dateStrings[0] || undefined
      this.queryParam.endTime = dateStrings[1] || undefined
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.multiple = !selectedRowKeys.length
    },
    handlePreview(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    previewCancel() {
      this.previewVisible = false
    },
    getStatusColor(status) {
      const colorMap = {
        0: 'orange',     // 待支付
        1: 'blue',       // 待接单
        2: 'cyan',       // 待服务
        3: 'processing', // 服务中
        4: 'green',      // 已完成
        5: 'red'         // 已取消
      }
      return colorMap[status] || 'default'
    },
    getAddPriceStatusColor(status) {
      const colorMap = {
        0: 'gold',      // 待确认
        1: 'blue',      // 已确认待支付
        2: 'green',     // 已支付
        3: 'red'        // 已拒绝
      }
      return colorMap[status] || 'default'
    },
    handleDetail(record) {
      this.$refs.detailForm.handleDetail(record)
    },
    handleAssignWorker(record) {
      this.currentOrderId = record.id
      this.assignForm = {
        orderId: record.id,
        workerId: undefined
      }
      // 获取师傅列表
      listWorker({ workerType: 2, auditStatus: 1, workStatus: 1 }).then(response => {
        this.workerList = response.data || []
      })
      this.assignWorkerVisible = true
    },
    assignWorkerCancel() {
      this.assignWorkerVisible = false
      this.assignForm = {
        orderId: null,
        workerId: undefined
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].children[1].children[1].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    submitAssignWorker() {
      if (!this.assignForm.workerId) {
        this.$message.warning(this.$t('服务订单.请选择师傅'))
        return
      }
      this.assignLoading = true
      assignWorker(this.assignForm).then(() => {
        this.$message.success(this.$t('通用.文本.操作成功'))
        this.assignWorkerCancel()
        this.getList()
      }).finally(() => {
        this.assignLoading = false
      })
    },
    handleDelete(row) {
      const ids = row.id || this.selectedRowKeys
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk: () => {
          const data = (Array.isArray(ids) ? ids : [ids]).map(id => ({ id }))
          return delHomeServiceOrder(data).then(() => {
            this.selectedRowKeys = []
            this.getList()
            this.$message.success(this.$t('通用.文本.删除成功'))
          })
        }
      })
    },
    handleExport() {
      this.exportLoading = true
      const param = { ...this.queryParam }
      delete param.pageNum
      delete param.pageSize
      // userInfo 搜索框同时搜索昵称和手机号（OR关系），后端接收字段为 nickName
      if (param.userInfo) {
        param.nickName = param.userInfo
        delete param.userInfo
      }
      exportHomeServiceOrder(param).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.ms-excel' })
        const filename = this.$t('服务订单.服务订单') + '_' + this.parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') + '.xls'
        saveAs(blob, filename)
        this.$message.success(this.$t('通用.文本.导出成功'))
      }).finally(() => {
        this.exportLoading = false
      })
    }
  }
}
</script>

<style scoped>
.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
